import React, { useState } from 'react'

import { Button, Grid, SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";


const useStyles = makeStyles({
    root: {
        width: '100%',
        backgroundColor: "#F5F7FA",
        padding: "7px"
    },
    tile: {
        height: "80px",
        backgroundColor: "#FFF",
        textAlign: "center",
        width: "80%",
        cursor: "pointer",
        color: "#393939",
        padding: "5%",
        border: "#67729429",
        '&:hover': {
            backgroundColor: "#3f51b5",
            color: "#F5F7FA"
        }
    },
    analyticwindow: {
        backgroundColor: "#F5F7FA",
        color: "#393939",
        width: "300px"
    },
    button: {
        marginRight: "5px",
        borderRadius: "10px"
    }
});
export default function ViewResearchReports() {

    const [selectedIndex, setSelectedIndex] = useState(0);
    let history = useHistory();
    let match = useRouteMatch();

    const [salesList, setSalesList] = useState([
        {
            id: 0,
            name: "User wise Portfolio",
            link: "viewmitreport"
        },
        {
            id: 1,
            name: "Stock wise Portfolio",
            link: 'viewmitreport'
        },
        {
            id: 2,
            name: "Goal Advices",
            link: 'goaladvices'
        },
    ]);

    const classes = useStyles();
    const handleListItemClick = (event, index, menuObject) => {
        if (menuObject.link) {
            // history.push(menuObject.link);
            history.push({
                // pathname: prospectPath,
                pathname: menuObject.link,
                state: index,
                id: menuObject.id,
                name: menuObject.name
            });
        } else {
            history.push(`${match.url}`);
        }
    }

    return (
        <>
            <>

                <Grid container style={{ marginTop: "20px" }} className={'prospectgrids'}>
                    {
                        salesList.map((e, index) => {
                            return (
                                <Grid item xs={12} sm={6} md={3}
                                    key={index}
                                    selected={selectedIndex === index}
                                    onClick={(event) => handleListItemClick(event, index, e)}
                                >
                                    <Paper className={classes.tile}>
                                        <Typography variant="h6">{e.name}</Typography>
                                    </Paper>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </>
        </>
    )
}